const error423 = {
  name: 'Erro 423',
  title: 'Firma temporalmente no disponible.',
  subtitle:
    '¡Qué pena! El orden de las firmas fue modificado por quien envió el documento. Te pedimos que esperes otra notificación. Así podrás firmar tranquilamente.',
};

export default error423;
